import { render } from "./DuplicateAccounts.vue?vue&type=template&id=068104a2"
import script from "./DuplicateAccounts.vue?vue&type=script&lang=js"
export * from "./DuplicateAccounts.vue?vue&type=script&lang=js"

import "./DuplicateAccounts.vue?vue&type=style&index=0&id=068104a2&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__